import moment, { Moment } from "moment"

interface ICreateDateParams {
  year?: string | number
  month?: string | number
  week?: string | number
  weekday?: string | number
}

export function createDate({ year, month, week, weekday }: ICreateDateParams): Moment {
  const date = moment.utc()
  year && date.isoWeekYear(Number(year))
  month && date.month(Number(month) - 1)
  week && date.isoWeek(Number(week))
  weekday && date.isoWeekday(Number(weekday))

  return date.startOf("day")
}
